module.exports = __webpack_public_path__ + "img/intellicare.e6729d35.png";